import OrderForm from "./OrderForm";
import './style/headerNav.css';

const OrderFormAdmin = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <>
            <div className="col-xl-12">
                <div className="page-titles">
                    {/* Fil d'Ariane moderne */}
                    <nav className="breadcrumb-modern" aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <span className="breadcrumb-main text-uppercase letter-spacing">Ordres</span>
                                <span className="breadcrumb-year-badge">{currentYear}</span>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                <span className="breadcrumb-current">Tableau de bord</span>
                            </li>
                        </ol>
                    </nav>
                
                    {/* Bouton d'action moderne */}
                    <div className="page-actions">
                        <button 
                            className="btn btn-primary btn-new-order"
                            data-bs-toggle="modal" 
                            data-bs-target="#newOrder"
                        >
                            <span className="btn-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z" fill="currentColor"/>
                                    <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z" fill="currentColor"/>
                                </svg>
                            </span>
                            <span className="btn-text">Nouvel Ordre</span>
                        </button>
                    </div> 
                </div>
            </div>
            
            <OrderForm/> 
        </>
    );
};

export default OrderFormAdmin;